




import { Vue, Component } from "vue-property-decorator";
import { mapState } from "vuex";

// Enums/Data
import { DataModules } from "@/store/modules/data";
import { QUERY_PARAMS } from "@/data/constants";

// Types
import { IBrand } from "@/models/brands";
import { IState } from "@/store";

@Component({
  computed: {
    ...mapState({
      brandId(state: IState) {
        return state.brand.id;
      }
    })
  }
})
export default class OpenAddEditGatewayModal extends Vue {
  // Map state

  public brandId!: IBrand["id"];

  // Methods

  public async created() {
    let gatewayProviderId = "";
    try {
      gatewayProviderId = this.$route.query[
        QUERY_PARAMS.GATEWAY_PROVIDER_ID
      ] as string;

      this.$router.replace({
        query: this.$_.omit(this.$route.query, [
          QUERY_PARAMS.GATEWAY_PROVIDER_ID
        ]),
        name: "brandPaymentProvidersSettings"
      });

      const gatewaysTotal = this.$_.get(
        await this.getBrandGateways(),
        "total",
        0
      );

      this.$store.dispatch(`data/${DataModules.GATEWAYS}/openManageGateway`, {
        gatewayProviderId,
        total: gatewaysTotal,
        ...this.$props
      });
    } catch {
      // mask error
    }
  }

  public getBrandGateways() {
    return this.$store.dispatch(`data/${DataModules.BRAND_GATEWAYS}/list`, {
      vm: this,
      brandId: this.brandId,
      storeData: false,
      returnData: false,
      params: {
        limit: "count"
      }
    });
  }
}
